import React, { useEffect, useState } from "react";
import "./NewsletterData.css";
import { BannerSkeleton } from "../../BannerSkeleton";

const NewsletterPopupData = (props: any) => {
  const [loading, setLoading] = useState(true);
  const {
    title,
    component,
    brand_color,
    flowdeskId,
    isHandleNavigate,
    from,
    designTokens,
  } = props;
  // Determine button styles based on templateName
  const isDefault = designTokens?.templateName?.toLowerCase() === "default";
  const getButtonStyles = () => {
    return {
      backgroundColor: isDefault ? "#000000" : designTokens?.forthColor,
      textColor: isDefault ? "#ffffff": designTokens?.secondaryColor,
    };
  };

  useEffect(() => {
    setTimeout(() => {
      setLoading(false);
    }, 400);
  }, []);

  useEffect(() => {
    // Flodesk Script Initialization
    (function (w: any, d: any, t: any, h: any, s: any, n: any) {
      w.FlodeskObject = n;
      const fn = function () {
        (w[n].q = w[n].q || []).push(arguments);
      };
      w[n] = w[n] || fn;
      const f = d.getElementsByTagName(t)[0];
      const v = "?v=" + Math.floor(new Date().getTime() / (120 * 1000)) * 60;
      const sm = d.createElement(t);
      sm.async = true;
      sm.type = "module";
      sm.src = h + s + ".mjs" + v;
      f.parentNode.insertBefore(sm, f);
      const sn = d.createElement(t);
      sn.async = true;
      sn.noModule = true;
      sn.src = h + s + ".js" + v;
      f.parentNode.insertBefore(sn, f);
    })(
      window,
      document,
      "script",
      "https://assets.flodesk.com",
      "/universal",
      "fd"
    );

    // Flodesk form initialization
    if (window.fd) {
      window.fd("form", {
        formId: `${flowdeskId}`,
        containerEl: `#fd-form-${flowdeskId}`,
      });
    }
    setLoading(false);
  }, [loading, flowdeskId]);

  const buttonStyles = getButtonStyles();
  return (
    <>
      {loading ? (
        <BannerSkeleton designTokens={designTokens} />
      ) : (
        <>
          <style>{`
            /* Default secondary font for all elements */
            #fd-form-${flowdeskId} div,
            #fd-form-${flowdeskId} span,
            #fd-form-${flowdeskId} label,
            #fd-form-${flowdeskId} input,
            #fd-form-${flowdeskId} button,
            #fd-form-${flowdeskId} textarea,
            #fd-form-${flowdeskId} select {
              font-family: ${designTokens?.secondaryFontFamily} !important;
            }
            
            /* Primary font for title (contains __title in class) */
            #fd-form-${flowdeskId} [class*="__title"] {
              font-family: ${designTokens?.primaryFontFamily} !important;
            }
            
            /* Secondary font for subtitle */
            #fd-form-${flowdeskId} [class*="__subtitle"] {
              font-family: ${designTokens?.secondaryFontFamily} !important;
            }

            #fd-form-${flowdeskId} {
              font-family: ${designTokens?.secondaryFontFamily} !important;
            }
            
            /* Button styles */
            #fd-form-${flowdeskId} button[type="submit"] {
              background-color: ${buttonStyles.backgroundColor} !important;
              color: ${buttonStyles.textColor} !important;
              font-family: ${designTokens?.secondaryFontFamily} !important;
            }
            #fd-form-${flowdeskId} button[type="submit"] span {
              color: ${buttonStyles.textColor} !important;
            }
            #fd-form-${flowdeskId} button:hover[type="submit"] {
              opacity: 0.9;
            }
            #fd-form-${flowdeskId} button:active[type="submit"] {
              opacity: 0.8;
            }
          `}</style>
          <div id={`fd-form-${flowdeskId}`}></div>
        </>
      )}
    </>
  );
};

export default NewsletterPopupData;